import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function UpdateTechnical() {
    const { plantName, technical_id, cogen_id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        boiler_make: '',
        boiler_pressure: '',
        boiler_temperature: '',
        boiler_capacity: '',
        furnes_type: '',
        fuel: '',
        turbine_make: '',
        turbine_capacity: '',
        cogen_plant_make: ''
    });

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://backend-zkgn.onrender.com/api/cogen_technical/${cogen_id}`);
                setFormData(response.data);
            } catch (error) {
                console.error('Error fetching technical data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [technical_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
    let tempErrors = {};
    let isValid = true;

    Object.entries(formData).forEach(([key, value]) => {
        const stringValue = value ? value.toString().trim() : '';
        if (!stringValue) {
            tempErrors[key] = `${key.replace(/_/g, ' ')} is required.`;
            isValid = false;
        }
    });

    setErrors(tempErrors);
    return isValid;
};

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        try {
            await axios.put(`https://backend-zkgn.onrender.com/api/cogen_technical/${technical_id}`, formData);
            setSuccessMessage('Technical Information Updated Successfully!');

            setTimeout(() =>{
                navigate(`/technical-information/${plantName}/${cogen_id}`);
            }, 1500);
        } catch (error) {
            console.error('Update error:', error);
        }
    };

    if (loading) return <div className="text-center">Loading...</div>;

    return (
        <div className="container my-4">
            {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 bg-light rounded">
                <div className="row g-3">
                    {Object.entries(formData).map(([key, value]) => (
                        <div className="col-md-6" key={key}>
                            <label className="form-label text-capitalize">{key.replace(/_/g, ' ')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={key}
                                value={value}
                                onChange={handleChange}
                            />
                            {errors[key] && <small className="text-danger">{errors[key]}</small>}
                        </div>
                    ))}
                </div>
                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary px-4">Update</button>
                </div>
            </form>
        </div>
    );
}

export default UpdateTechnical;
